import { useState, useEffect } from "react"
import isNil from "ramda/src/isNil"
import isEmpty from "ramda/src/isEmpty"

import {
  downloadDemandsFiles,
  downloadAudio
} from "services/state/repair/action"

export const useAudioDemandFile = (demand) => (dispatch, getState) => {
  const [state, setState] = useState({
    audioBase64: null,
    loading: true,
    error: false
  })

  useEffect(() => {
    if (isNil(demand.fileAudioURL) || isEmpty(demand.fileAudioURL)) return

    downloadDemandsFiles(demand, (data) => {
      downloadAudio(data.payload.data.pathURL, (res) => {
        if (res.type === "DOWNLOAD_AUDIO_FAIL") {
          setState({
            audioBase64: null,
            loading: false,
            error: true
          })

          return
        }

        const audioData = res.payload.data

        const buffer = new Blob([audioData], {
          type: "application/octet-binary"
        })
        const reader = new FileReader()
        reader.readAsDataURL(buffer)
        reader.onloadend = () => {
          const base64Data = reader.result
          setState({
            audioBase64: base64Data,
            loading: false
          })
        }
      })(dispatch)
    })(dispatch, getState)
  }, [])

  return { ...state, audio: demand.audio, fileAudioURL: demand.fileAudioURL }
}



// WEBPACK FOOTER //
// ./src/scenes/IncidentManager/components/utils/useAudioDemandFile.js